import {
  Box,
  IconButton,
  Popover,
  TableCell,
  TableRow,
  Typography,
} from "@mui/material";
import axios from "axios";
import React, { useEffect, useMemo } from "react";
import InfoIcon from "@mui/icons-material/Info";
import { getNumericDate } from "../../../_utils/getNumericDate";

const TaskItem: React.FC<any> = ({ row, handleClick }) => {
  const [check, setCheck] = React.useState(row.check);
  const [anchorEl, setAnchorEl] = React.useState(null);

  const popoverClick = (event: any) => {
    event.stopPropagation();
    setAnchorEl(event.currentTarget);
  };

  const handleClose = (e: any) => {
    e.stopPropagation();
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? "popover-" + row.id : undefined;

  useEffect(() => {
    if (row.check !== check) {
      updateCheck(row.check);
      setCheck(row.check);
    }

    return () => {};
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [row]);

  const onClick = () => {
    handleClick(row.id);
  };

  const updateCheck = async (finished: boolean) => {
    try {
      await axios.put(`tasks/${row.id}`, { finished });
    } catch {}
  };

  const date = useMemo(
    () => (row.date ? getNumericDate(row.date) : null),
    [row.date]
  );

  return (
    <TableRow
      key={row.index}
      sx={{
        "&:last-child td, &:last-child th": { border: 0 },
        marginBottom: "8px",
        display: "block",
        cursor: "pointer",
        userSelect: "none",
      }}
      onClick={onClick}
    >
      <TableCell align="left" sx={{ padding: "4px", width: "10%" }}>
        {row.index}
      </TableCell>
      <TableCell
        align="left"
        sx={{
          padding: "4px",
          width: "80%",
          color: row.check ? "#a9a9a9" : "inherit",
          textDecoration: row.check ? "line-through" : "none",
        }}
      >
        <Typography>{row.name}</Typography>
        {row.date && (
          <Box>
            <Typography
              sx={{
                color: (theme: any) =>
                  row.check
                    ? "inherit"
                    : theme.palette[
                        row.status === "passed"
                          ? "error"
                          : row.status === "future"
                          ? "success"
                          : "warning"
                      ][600],
              }}
              variant="caption"
            >
              {date}
            </Typography>
          </Box>
        )}
      </TableCell>
      {row.description && (
        <TableCell align="left" sx={{ padding: "4px", width: "10%" }}>
          <IconButton sx={{ padding: 0 }} onClick={popoverClick}>
            <InfoIcon sx={{ fontSize: "20px" }} />
          </IconButton>
          <Popover
            id={id}
            open={open}
            anchorEl={anchorEl}
            onClose={handleClose}
            anchorOrigin={{
              vertical: "bottom",
              horizontal: "left",
            }}
          >
            <Typography sx={{ p: 2 }}>{row.description}</Typography>
          </Popover>
        </TableCell>
      )}
    </TableRow>
  );
};

export default TaskItem;
